if (!customElements.get('quick-shop')) {
  class Quickshop extends HTMLElement {
    connectedCallback() {
      this.productCardAtc = this.querySelector('product-card-atc');
      this.optionInputs = this.querySelectorAll('[data-quickshop-option]');

      this.optionInputs.forEach((option) => {
        option.addEventListener('change', () => this.onOptionSelect(option));
      });

      const checkedOption = this.querySelector('[data-quickshop-option]:checked');
      if (checkedOption) this.onOptionSelect(checkedOption);
    }

    onOptionSelect(option) {
      if (!this.productCardAtc) return;
      this.productCardAtc.setVariant(option.value, !option.disabled);
    }
  }

  window.Quickshop = Quickshop;
  customElements.define('quick-shop', Quickshop);
}
